import { render, staticRenderFns } from "./ExportRecordDOILink.vue?vue&type=template&id=0ba236dc"
import script from "./ExportRecordDOILink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportRecordDOILink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports